// extracted by mini-css-extract-plugin
module.exports = {"main":"CarouselRow_main__2VMcL","row":"CarouselRow_row__2enNd","left":"CarouselRow_left__3iX0r","right":"CarouselRow_right__1bPgT","component":"CarouselRow_component__3aNg5"};